import { Tag, TagsIcon } from 'lucide-react';
import { useMapStore } from '@/stores/map-store';

/**
 * HUD chip that toggles the 3D photorealistic label overlay (HYBRID ↔ SATELLITE).
 * Turning labels off yields a cleaner, less cluttered photorealistic image.
 * Only shown in 3D, where the overlay exists.
 */
export function MapLabelsControl(): React.JSX.Element | null {
  const viewMode = useMapStore((s) => s.viewMode);
  const labelsVisible = useMapStore((s) => s.labelsVisible);
  const toggleLabels = useMapStore((s) => s.toggleLabels);

  if (viewMode !== '3d') return null;
  const Icon = labelsVisible ? TagsIcon : Tag;

  return (
    <button
      type="button"
      onClick={toggleLabels}
      title={labelsVisible ? 'Hide labels (cleaner imagery)' : 'Show labels'}
      aria-pressed={labelsVisible}
      className="flex items-center gap-2 rounded-lg border border-echo-border bg-echo-grey/90 px-2.5 py-2 shadow-lg backdrop-blur transition-colors hover:border-echo-border/80"
    >
      <Icon className={`h-4 w-4 ${labelsVisible ? 'text-echo-yellow' : 'text-muted-foreground'}`} />
      <span className="font-chakra text-xs font-semibold uppercase tracking-wider text-foreground">
        Labels {labelsVisible ? 'On' : 'Off'}
      </span>
    </button>
  );
}
